import { defineComponent as _defineComponent } from 'vue'
import PageHeading from "@/components/PageHeading.vue";
import SearchBar from "@/components/SearchBar.vue";
import SearchResults from "@/components/SearchResults.vue";
import BriefcaseFolderMoveDialog from "@/components/BriefcaseFolderMoveDialog.vue";

import { MetadataKeys } from "@/types";
import { onMounted, ref } from "vue";
import { useViewAnalytics } from "@/composition/useViewAnalytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPage',
  setup(__props) {

const pageName = ref("Search");
const { pageTitle, setAnalyticsMetadata, pushPageViewEvent } =
  useViewAnalytics(pageName);

onMounted(() => {
  setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Search or Content List");
  setAnalyticsMetadata(MetadataKeys.SITESECTION, "Search or Content List");
  pushPageViewEvent();
});

return { __sfc: true,pageName, pageTitle, setAnalyticsMetadata, pushPageViewEvent, PageHeading, SearchBar, SearchResults, BriefcaseFolderMoveDialog }
}

})